'use client';

import useEmblaCarousel from 'embla-carousel-react';
import ArticleCard from './ArticleCard';
import { useBlogTheme } from '@/hooks/useBlogTheme';

export const RelatedBlogs = ({ heading, blogs = [] }) => {
  const { isBlogLightTheme } = useBlogTheme();
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
  });
  if (blogs.length === 0) return null;

  const formattedRelatedArticles = blogs.map((blog) => ({
    name: blog?.related_blog_id?.name,
    banner: blog?.related_blog_id?.banner,
    slug: blog?.related_blog_id?.slug,
    author: blog?.related_blog_id?.author,
    author_profile: blog?.related_blog_id?.author_profile,
    published_date: blog?.related_blog_id?.published_date,
    content_read_time: blog?.related_blog_id?.content_read_time,
  }));

  return (
    <article className="py-[100px] md:py-[192px]">
      <header className="mx-auto w-fit text-center">
        <h3
          className={`mb-2 md:mb-4 font-instrument-serif text-[22px] ${
            isBlogLightTheme && 'text-[#404040]'
          }`}
        >
          Related articles
        </h3>
        <h3
          className={`font-inter-tight ${
            isBlogLightTheme ? 'text-black' : 'text-[#1FBCCB]'
          } text-[28px] leading-[24px]`}
        >
          You may also like
        </h3>
      </header>

      <section className="right-side-bleed mt-[35px] md:mt-[98px] pl-[30px] md:pl-[70px]">
        <div ref={emblaRef} className="overflow-hidden">
          <div className="flex -ml-5 md:-ml-7 md:pr-7">
            {formattedRelatedArticles.map((article, idx) => (
              <div
                key={idx}
                className="min-w-0 flex-[0_0_90.909%] sm:flex-[0_0_66.667%] md:flex-[0_0_463px] pl-5 md:pl-7"
              >
                <ArticleCard article={article} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </article>
  );
};
